import * as bowser from "bowser";

const DeviceDetector = require("device-detector-js");

export const AKAMAI_DC_KIND = {
  isMobile: "is_mobile",
  isTablet: "is_tablet",
};

export const getDeviceType = (
  userAgent: string,
  opts: { akamaiDCHeaders: Record<string, string>; isDesktop: boolean },
  req: any
) => {
  let pwaApp = true;
  const { akamaiDCHeaders, isDesktop } = opts || {};
  const desktopView = isDesktop || req?.cookies?.["isDesktop"];

  const domain = ".makemytrip.com";

  const akamaiIsMobile = akamaiDCHeaders?.[AKAMAI_DC_KIND.isMobile];
  if (akamaiIsMobile === "true") {
    pwaApp = true;
    return pwaApp;
  }
  if (akamaiIsMobile === "false") {
    pwaApp = false;
    return pwaApp;
  }

  if (userAgent) {
    const browser = bowser.getParser(userAgent);
    const platform = browser.getPlatform().type;
    if (platform === "bot") {
      const deviceDetector = new DeviceDetector();
      const { device } = deviceDetector.parse(userAgent);
      pwaApp = false;
      if (device && device.type === "smartphone") {
        pwaApp = true;
      }
    } else if (platform === "desktop") {
      pwaApp = false;
    }
  } else {
    pwaApp = false;
  }
  return pwaApp;
};
